import {
	Box,
	FormControl,
	Grid,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { colors, sizes } from "../../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { getCGRefData, resetAllStates, setCGState } from "../customerGroupSetupSlice";

export default function CreateCG() {
	const cgState = useSelector((store) => store.customerGroupSetup);
	const {
		countries,
		country,
		countryID,
		createFromDate,
		createToDate,
		customerTypes,
		customerType,
		customerTypeCode,
		createCGName,
      selCustomers,
	} = cgState;
	const dispatch = useDispatch();

   const minDate = dayjs().add(1, 'day');

	function showMessage(message, severity) {
		dispatch(setCGState("createMessage", message));
		dispatch(setCGState("createMessageSeverity", severity));
		dispatch(setCGState("createMessageOpen", true));
	}

	function updateCountry(event) {
		const countryName = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === countryName
		).countryID;
		dispatch(setCGState("country", countryName));
		dispatch(setCGState("countryID", countryID));

      //reset all states 
      resetStatesOnCountryChange();

      dispatch(getCGRefData({ countryID }))
	}

   function resetStatesOnCountryChange() {
      dispatch(setCGState("customerType", ""));
		dispatch(setCGState("customerTypeCode", ""));
      dispatch(setCGState("createCGName", ""));
      dispatch(setCGState("createFromDate", dayjs().add(1, "day")));
      dispatch(setCGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
      dispatch(setCGState("customerLevel", ""));
		dispatch(setCGState("customerLevelID", ""));
      dispatch(setCGState("relShipLevel", ""));
		dispatch(setCGState("relShipLevelID", ""));
      dispatch(setCGState("customerName", ""));
      dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));
      dispatch(setCGState("createComments", ""));
      dispatch(setCGState("files", []));
	  dispatch(setCGState("is_refresh", true));
   }

	function updateCustomerType(event) {
		if (country.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}

		const type = event.target.value;
		const typeCode = customerTypes.find(
			(cType) => cType.customerTypeName === type
		).customerTypeCode;
		dispatch(setCGState("customerType", type));
		dispatch(setCGState("customerTypeCode", typeCode));
      dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));
		dispatch(setCGState("is_refresh", true));
	}

	function updateCreateCGName(event) {
		const pattern = /^[a-zA-Z0-9 ]*$/;
		//let inputChar = String.fromCharCode(event.charCode)
		if (event.target.value == " ") {
		  event.target.value = event.target.value.replace(" ", "");
		}
		else if (event.target.value.startsWith(" ")) {
		  event.target.value = event.target.value.trimStart();
		}
		if (!pattern.test(event.target.value)) {
		  event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, "");	
		}
		if (customerType.length <= 0) {
			showMessage("Please select customer type first", "info");
			return;
		}
		const name = event.target.value;
		dispatch(setCGState("createCGName", name));
	}

	function updateCreateFromDate(newDate) {
		if (createCGName.length <= 0) {
			showMessage("Please enter a customer group name first", "info");
         dispatch(setCGState("createFromDate", dayjs().add(1, "day")));
			return;
		}
		if (newDate >= createToDate) {
			showMessage("From date should be less than To date", "info");
         dispatch(setCGState("createFromDate", dayjs().add(1, "day")));
			return;
		}
		dispatch(setCGState("createFromDate", newDate));
      if(selCustomers.length > 0) {
         updateFromDateForSelCustomers(newDate);
      }
	}

   function updateFromDateForSelCustomers(date) {
      const updated = selCustomers.map((item) => {
         return {
            ...item,
            effectiveStartDate: date, 
         };
      });
      dispatch(setCGState("selCustomers", updated));
   }

	function updateCreateToDate(newDate) {
		if (createCGName.length <= 0) {
			showMessage("Please enter a customer group name first", "info");
         dispatch(setCGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			return;
		}
		if (newDate <= createFromDate) {
			showMessage("To date should be greater than From date", "info");
         dispatch(setCGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			return;
		}
		if (newDate.diff(createFromDate, "day") < 7) {
			showMessage("Validity must be at least 7 days", "info");
         dispatch(setCGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			return;
		}
		dispatch(setCGState("createToDate", newDate));
      if(selCustomers.length > 0) {
         updateToDateForSelCustomers(newDate);
      }
	}

   function updateToDateForSelCustomers(date) {
      const updated = selCustomers.map((item) => {
         return {
            ...item,
            effectiveEndDate: date, 
         };
      });
      dispatch(setCGState("selCustomers", updated));
   }

	return (
		<Box sx={{ mt: 3,}}>
			{/* COUNTRY, TYPE, CUSTOMER GROUP NAME */}
			<Grid container columns={12} spacing={2} rowGap={2} alignContent={"space-between"}>
				<Grid item sm={2}>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={country}
							label="Country"
							sx={{
								height: sizes.h35,
								width: sizes.w300,
								color: colors.black,
								mt: 1,
							}}
							onChange={updateCountry}
						>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item sm={2}>
					<FormControl>
						<InputLabel>Type</InputLabel>
						<Select
							value={customerType}
							label="Customer Type"
							sx={{
								height: sizes.h35,
								width: sizes.w300,
								color: colors.black,
								mt: 1,
							}}
							onChange={updateCustomerType}
						>
							{customerTypes.map((type, index) => {
								return (
									<MenuItem key={index} value={type.customerTypeName}>
										{type.customerTypeCode} | {type.customerTypeName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item sm={4}>
					<TextField
						label="Customer Group Name"
						InputProps={{
							startAdornment: (
								<InputAdornment position="end">
									<EditIcon />
								</InputAdornment>
							),
						}}
						variant="standard"
						value={createCGName}
						onChange={updateCreateCGName}
					/>
				</Grid>
				<Grid item sm={2}>
					<Box sx={{ mt: 1 }}>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker
                        minDate={minDate}
								label="From"
								value={createFromDate}
								onChange={(newValue) => updateCreateFromDate(newValue)}
								renderInput={(params) => (
									<TextField
										{...params}
										size="small"
										sx={{ width: sizes.w300 }}
									/>
								)}
								format="DD/MM/YYYY"
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
				<Grid item sm={2}>
					<Box sx={{ mt: 1 }}>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker
								minDate={minDate}
								label="To"
								value={createToDate}
								onChange={(newValue) => updateCreateToDate(newValue)}
								renderInput={(params) => (
									<TextField
										{...params}
										size="small"
										sx={{ width: sizes.w300 }}
									/>
								)}
								format="DD/MM/YYYY"
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
